import { render, staticRenderFns } from "./userDashboardCustomerInfos.vue?vue&type=template&id=056ca6d2&scoped=true"
import script from "./userDashboardCustomerInfos.vue?vue&type=script&lang=js"
export * from "./userDashboardCustomerInfos.vue?vue&type=script&lang=js"
import style0 from "./userDashboardCustomerInfos.vue?vue&type=style&index=0&id=056ca6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ca6d2",
  null
  
)

export default component.exports